import type { NodeId } from 'web';
import type { FlowGraph } from '../FlowGraph';
import type { ListSelectorData } from '@/types/node';

const inputKey = 'options';
export class ListSelectorView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  setSelected(selected: number) {
    this.graph.wasmEdit((wasm) => {
      return wasm.setSelected(this.nodeId, selected);
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  setIsIterator(isIterator: boolean) {
    this.graph.wasmEdit((wasm) => {
      return wasm.setIsIterator(this.nodeId, isIterator);
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  setOptions(list: string[]) {
    const nodeData = this.graph.store.getNodeDataNullable<ListSelectorData>(this.nodeId);
    if (!nodeData) return;
    this.graph.wasmEdit((wasm) => wasm.setListSelector(this.nodeId, list, nodeData.delimiter));
    this.graph.updateNodeOutputs(this.nodeId);
  }

  setDelimiter(delimiter: string) {
    const nodeData = this.graph.store.getNodeDataNullable<ListSelectorData>(this.nodeId);
    if (!nodeData) return;
    this.graph.wasmEdit((wasm) => wasm.setListSelector(this.nodeId, nodeData.list, delimiter));
    this.graph.updateNodeOutputs(this.nodeId);
  }

  hasInput() {
    const nodeData = this.graph.store.getNodeDataNullable<ListSelectorData>(this.nodeId);
    if (!nodeData) return false;
    const inputType = this.graph.wasm.call((wasm) => wasm.nodeInputType(this.nodeId, inputKey));
    return inputType === 'text' || inputType === 'array';
  }

  hasStringInput() {
    const nodeData = this.graph.store.getNodeDataNullable<ListSelectorData>(this.nodeId);
    if (!nodeData) return false;
    const inputType = this.graph.wasm.call((wasm) => wasm.nodeInputType(this.nodeId, inputKey));
    return inputType === 'text';
  }
}
